
import { UserAuditEventMetadataBase } from './user-audit-event.metadata.base';


export class UserAuditEventMetadata extends UserAuditEventMetadataBase {
  constructor() {
    super();
  }
}

export const USER_AUDIT_EVENT_METADATA: UserAuditEventMetadata = new UserAuditEventMetadata();


